import { capitalize } from '@mui/material';
import { useMemo } from 'react';
import useAppNavigator from 'views/rebranded-module/common/hooks/useAppNavigator';
import { mapNamedLocaleToDayJsLocale } from 'views/common/utils/dayjsLocales';

const WEEKDAY_ORDER = [6, 0, 1, 2, 3, 4, 5]; // Start with Sunday
const DIGITS = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
const MERIDIEMS = [
  ['AM', 'am'],
  ['PM', 'pm'],
];

const useRangePickerLocalization = () => {
  const appNavigator = useAppNavigator();

  const localizationObj = useMemo(() => {
    const dayjsLocaleValues = mapNamedLocaleToDayJsLocale[appNavigator.locale];
    if (!dayjsLocaleValues?.months) return undefined;
    const multiPickerValues = {
      name: `gregorian_${dayjsLocaleValues.name}`,
      months: [],
      weekDays: [],
      digits: DIGITS,
      meridiems: MERIDIEMS,
    };

    if (typeof dayjsLocaleValues.months === 'function') return undefined;

    dayjsLocaleValues.months.forEach((month, index) => {
      multiPickerValues.months.push([
        capitalize(month),
        capitalize(dayjsLocaleValues.monthsShort[index]),
      ]);
    });

    WEEKDAY_ORDER.forEach((dayIndex) => {
      multiPickerValues.weekDays.push([
        capitalize(dayjsLocaleValues.weekdays[dayIndex]),
        capitalize(dayjsLocaleValues.weekdaysMin[dayIndex]),
      ]);
    });

    return multiPickerValues;
  }, []);
  return localizationObj;
};

export default useRangePickerLocalization;
